export default {
	"base": {
		"labelWidth": "65px",
		"mode": "1",
		"isShowTable": true
	},
	"search": [],
	"props": [{
			"label": "文章名",
			"prop": "article_title",
		},
		{
			"label": "沟通历史",
			"prop": "feedback",
		},
		{
			"label": "作者",
			"prop": "author",
		},
		{
			"label": "投稿类型",
			"prop": "cb_type",
			"width": "90px"
		},
		{
			"label": "投稿时间",
			"prop": "add_time",
			"width": "160px"
		},
		{
			"label": "是否待修改",
			"prop": "to_be_modified",
			"width": "120px"
		},
		{
			"label": "状态",
			"prop": "status",
			"width": "200px"
		},
		{
			"label": "操作",
			"prop": "oper",
			"width": "120px"
		}
	]
}
